import React, { memo } from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory } from "react-router";
import Cookies from "js-cookie";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const useStyles = makeStyles((theme: any) => ({
  buttonsContainer: {
    // width: "480px",
  },
  row: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  prevBtn: {
    width: "206px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#245fad",
    backgroundColor: "#FFFFFF",
    border: "1px solid #245fad",
    transition: "0.3s",
    marginRight: "15px",
    cursor: "pointer",
    height: "51px",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#245fad",
      color: "white",
    },
  },
  skipBtn: {
    width: "206px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#FFFFFF",
    backgroundColor: "#245fad",
    border: "1px solid #245fad",
    transition: "0.3s",
    cursor: "pointer",
    height: "51px",
    borderRadius: "10px",
    "&:disabled": {
      background: "#245fad",
      opacity: "0.5",
      cursor: "not-allowed",
    },
  },
}));

interface INextOrSkipButtons {
  nextPagePath: string;
  wrapperClassName?: any;
  nextButtonText?: string;
  disabled?: boolean;
  nextOrSkipBtnAction?: React.MouseEventHandler<HTMLButtonElement>;
  handleChooseGiftCards?: any;
  isChooseButtonVisible?: boolean;
  chooseButtonDisabled?: boolean;
  hasBackButton?: boolean;
  hasNextButton?: boolean;
}

const NextOrSkipButtons = ({
  nextButtonText = "Բաց թողնել",
  nextPagePath = "next",
  hasNextButton = true,
  disabled = false,
  wrapperClassName = "",
  handleChooseGiftCards,
  nextOrSkipBtnAction,
  isChooseButtonVisible = false,
  chooseButtonDisabled = false,
  hasBackButton = true,
}: INextOrSkipButtons) => {
  const history = useHistory();
  const classes = useStyles();

  const previousPageHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (Cookies.get("uniqueId")) {
      history.goBack();
    } else {
      window.location.href = "/";
    }
  };

  const skipHandler = (event: any) => {
    if (nextOrSkipBtnAction) {
      nextOrSkipBtnAction(event);
      history.push(`/${nextPagePath}`);
    } else {
      history.push(`/${nextPagePath}`);
    }
  };

  return (
    <div
      className={`${classes.buttonsContainer} ${wrapperClassName} buttons-container-responsive`}
    >
      <div className={`${classes.row} row-responsive`}>
        {hasBackButton && (
          <button
            className={classes.prevBtn}
            type="button"
            onClick={previousPageHandler}
          >
            <ArrowBackIcon />
          </button>
        )}

        {hasNextButton && (
          <button
            className={classes.skipBtn}
            onClick={skipHandler}
            disabled={disabled}
            type="button"
          >
            {nextButtonText}
          </button>
        )}

        {isChooseButtonVisible && (
          <button
            style={{ marginLeft: 12 }}
            className={classes.skipBtn}
            onClick={handleChooseGiftCards}
            type="button"
            disabled={chooseButtonDisabled}
          >
            {/* Առաջ */}
            <ArrowForwardIcon />
          </button>
        )}
      </div>
    </div>
  );
};

export default memo(NextOrSkipButtons);
